import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_75: DocMigration = {
  maxSchemaVersion: "0.0.75",
  description: "Fix entityType field of paramRefs, add paramRefs where not present",
  apply(json: any) {
    if (!json.params) {
      json.params = {};
    }

    if (!json.paramRefs) {
      json.paramRefs = {};
    }

    for (const paramRefId in json.paramRefs) {
      delete json.paramRefs[paramRefId].type;
      json.paramRefs[paramRefId].entityType = "PARAM_REF";
    }

    let counter = 0;
    for (const paramId in json.params) {
      if (!json.paramRefs[paramId]) {
        json.paramRefs[paramId] = {
          entityType: "PARAM_REF",
          id: paramId,
          parentId: undefined,
          sortIndex: counter++,
        };
      }
    }
    return json;
  },
};

export default migration_0_0_75;
